/* QBik by KD — "Yenileniyoruz" section (v2): mobile photo counter, password dialog. */
(function () {
  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  // On narrow screens the photographs become a swipeable strip; keep the "01 / 03" counter in sync.
  function initCounter(root) {
    var strip = root.querySelector('[data-qcs-panels]');
    var current = root.querySelector('[data-qcs-current]');
    if (!strip || !current || !('IntersectionObserver' in window)) return;

    var panels = Array.prototype.slice.call(strip.querySelectorAll('[data-qcs-panel]'));
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            current.textContent = pad(panels.indexOf(entry.target) + 1);
          }
        });
      },
      { root: strip, threshold: 0.6 }
    );
    panels.forEach(function (panel) {
      observer.observe(panel);
    });
  }

  function initDialog(root) {
    var dialog = root.querySelector('[data-qcs-dialog]');
    if (!dialog || typeof dialog.showModal !== 'function') return;

    root.querySelectorAll('[data-qcs-open-dialog]').forEach(function (button) {
      button.addEventListener('click', function () {
        dialog.showModal();
        var input = dialog.querySelector('input[type="password"]');
        if (input) input.focus();
      });
    });

    dialog.querySelectorAll('[data-qcs-close-dialog]').forEach(function (button) {
      button.addEventListener('click', function () {
        dialog.close();
      });
    });

    dialog.addEventListener('click', function (event) {
      if (event.target === dialog) dialog.close();
    });

    // Wrong password → Shopify re-renders the page with errors; reopen the dialog.
    if (dialog.getAttribute('data-open') === 'true') dialog.showModal();
  }

  function init(root) {
    if (root.getAttribute('data-qcs-ready')) return;
    root.setAttribute('data-qcs-ready', 'true');
    initCounter(root);
    initDialog(root);
  }

  function initAll(scope) {
    (scope || document).querySelectorAll('[data-qcs]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
    });
  } else {
    initAll();
  }

  // Theme editor: re-run when the section is re-rendered.
  document.addEventListener('shopify:section:load', function (event) {
    initAll(event.target);
  });
})();
